
import { Component, Mixins } from "vue-property-decorator";
import { Bookmark } from "../../../../../../documaker/domain/format/objects";
import { IBookmarkPropertyEditable, instanceOfIBookmarkPropertyEditable } from "../../../../../domain/editableFormat/properties";

@Component
export default class BookmarkPropertyEditableMixin extends Mixins() {
  writePropertyWhenValid: (writer: (source: IBookmarkPropertyEditable) => void) => void;
  readPropertyOrDefault: <T>(reader: (source: IBookmarkPropertyEditable) => T, defaultValue: T) => T;

  get isBookmarkPropertyEditable(): boolean {
    return this.readPropertyOrDefault(s => instanceOfIBookmarkPropertyEditable(s) && s.bookmark().isEditable(), false);
  }

  get bookmark(): Bookmark {
    return this.readPropertyOrDefault(s => Bookmark.from(s.bookmark().getValue()), new Bookmark(false, "", 1, 1));
  }

  set bookmark(value: Bookmark) {
    this.writePropertyWhenValid(s => s.bookmark().setValue(Bookmark.to(value)));
  }
}

